import { FC, ReactNode } from 'react'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'

import styles from './VerticalSection.module.scss'

export type VerticalSectionProps = {
	title?: string
	titlePosition?: `center` | `start` | `end`
	subtitle?: string
	borderNone?: boolean
	children?: ReactNode
	className?: string
}

export const VerticalSection: FC<VerticalSectionProps> = ({
	title,
	titlePosition = `start`,
	children,
	subtitle,
	borderNone,
	className
}) => {
	const cls = [styles.verticalSection]
	if (className) cls.push(className)
	if (borderNone) cls.push(styles.borderNone)

	const titleAlignmentClassName: string =
		titlePosition === 'center' ? styles.titleCenter : titlePosition === 'end' ? styles.titleEnd : styles.titleStart

	return (
		<section className={cls.join(' ')}>
			<div className={styles.topPanel}>
				{!!title && (
					<h2
						className={[styles.title, titleAlignmentClassName].join(' ')}
						dangerouslySetInnerHTML={createMarkup(title)}
					/>
				)}
				{subtitle && <p className={styles.subtitle}>{subtitle}</p>}
			</div>
			<div className={styles.content}>{children}</div>
		</section>
	)
}
